import React, { useState, useEffect } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import InstituteSidebar from '../../components/InstituteSidebar';
import Card from '../../components/Card';
import { useNavigate } from 'react-router-dom';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';

const InstituteDashboard = () => {
    const navigate = useNavigate();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const [instituteCount, setInstituteCount] = useState();

    useEffect(() => {
        getInstituteCount();
    }, []);

    const getInstituteCount = () => {
        const apiUrlForInstituteList = `/all-dashboard-count?instituteMasterId=${instituteMasterId}`;

        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForInstituteList)
            .then(response => {
                setInstituteCount(response.data.result);
                console.log('Institute data:', response.data.result);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }


    // const changeActive = (id,activationStatus) => {

    //     const data = {}
    //     data.id = id;
    //     data.adminDeActivate = activationStatus;

    //     const apiUrl = `/institute-de-activation`;
    //     authorizedAxios && authorizedAxios.patch(apiUrl, data)
    //         .then(response => {
    //             setActivation(!activation);

    //             setTimeout(() => {
    //                 Swal.fire({ text: response.data.message });
    //                 console.log('Data:', response.data);
    //             }, 100);

    //         })
    //         .catch(error => {
    //             console.error('Error fetching data:', error);
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //                 Swal.fire(
    //                     { text: errorMsg }
    //                 );
    //         });

    // }

    return (
        <>
            {/* <InstituteSidebar /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item active"><span>Dashboard</span></li>
                    </ol>
                </nav>

                <div className="body flex-grow-1 px-3">
                    <div className="container-lg">
                        <div className="row">

                            <div class="Dcard-container">

                                <div class="Dcard"  onClick={() => navigate("/institute-dashboard-section-list")} >
                                    <i class="fa-solid fa-sitemap"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Section</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteSectionCount?.activeInstituteSection + instituteCount?.institueteCounts?.InstituteSectionCount?.deActiveInstituteSection}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Section</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteSectionCount?.activeInstituteSection}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Section</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteSectionCount?.deActiveInstituteSection}</div>
                                        </li>
                                       
                                    </ul>
                                    <div className='title'><h2>Section Count</h2></div>
                                </div>
                               

                                <div class="Dcard" onClick={() => navigate("/institute-dashboard-student-list")}>
                                    <i class="fa-solid fa-users-line"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Student</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstitueteStudentCount?.activeStudent + instituteCount?.institueteCounts?.InstitueteStudentCount?.deActiveStudent}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Student</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstitueteStudentCount?.activeStudent}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Student</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstitueteStudentCount?.deActiveStudent}</div>
                                        </li>
                                       
                                    </ul>
                                    <div className='title'><h2>Student Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/institute-dashboard-teacher-list")}>
                                    <i class="fa-solid fa-person-chalkboard"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Teacher</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteTeacherCount?.activeTeacher + instituteCount?.institueteCounts?.InstituteTeacherCount?.deActiveTeacher}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Teacher</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteTeacherCount?.activeTeacher}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Teacher</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteTeacherCount?.deActiveTeacher}</div>
                                        </li>
                                    
                                    </ul>
                                    <div className='title'><h2>Teacher Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/institute-dashboard-study-material-list")}>
                                    <i class="fa-solid fa-book"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Syllabus Structure</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteSyllabusStructureCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Pdf Of Books </h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstitutePdfBookCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Refrence Book</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteReferenceBookCount}</div>
                                        </li>
                                        <li>
                                            <h4> Total No Of Video</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteVideoCount}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Study Material Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/institute-dashboard-question-bank")}>
                                    <i class="fa fa-question-circle"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Text Book Question Count</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteTextBookQuestionCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Competitive Question Count</h4>
                                            <div className='count'>{instituteCount?.institueteCounts?.InstituteCompetitiveQuestionCount}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Question Bank Question Count</h2></div>
                                </div>

                               
                                {/* <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 2</h2></div>
                                </div>

                                <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 3</h2></div>
                                </div> */}
                                {/* <div class="Dcard" >
                                    <i class="fa-solid fa-users-line"></i>
                                    
                                    <div className='title'><h2>Card 4</h2></div>
                                </div> */}
                               
                              
                            </div>

                        </div>

                    </div>
                </div>


                <div className="col-md-12 mt-4">  </div>



            </div>
            <Footer />
        </>
    )
};

export default InstituteDashboard;